import { buildTripPath } from "utils/urlUtils";

/**
 * A full page load into the trip that was just created: it is an app route the marketing router does not know.
 * Its own module so a test can replace it (jsdom's `window.location` can be neither redefined nor spied on).
 */
export function openTrip(trip: { _id: string; name: string }): void {
	window.location.assign(buildTripPath(trip));
}
